import React, {memo} from 'react'
import {Timeline} from 'antd'
import EmptyDot from "../../../lib/components/empty-dot/empty-dot";
import {HStack} from "../../../../../../ui/Stack";
import cls from './activity-timeline-space.module.css'
import {classNames} from "../../../../../../lib/classNames/classNames";


interface ActivityTimelineSpaceProps {
    className?: string;
    text?: string;
}

function ActivityTimelineSpace({className, text}: ActivityTimelineSpaceProps) {
    return (
        <HStack justify={"center"} align={"start"}>
            <div className={classNames(cls.line, {}, [className])}/>
            <div className={cls.titleWrapper}>
                <span>{text}</span>
            </div>
        </HStack>
    )
}
export default memo(ActivityTimelineSpace);
